import { statusTypes } from "constants/common"
import {
  GET_BILLS_FAIL,
  GET_BILLS_SUCCESS,
  GET_BILL_DETAIL_FAIL,
  GET_BILL_DETAIL_SUCCESS,
  ADD_BILL_SUCCESS,
  ADD_BILL_FAIL,
  UPDATE_BILL_SUCCESS,
  UPDATE_BILL_FAIL,
  CLEAR_MESSAGE,
  DELETE_BILL_SUCCESS,
  DELETE_BILL_FAIL,
  UPDATE_BILL_ACCESS_SUCCESS,
  UPDATE_BILL_ACCESS_FAIL,
  GET_BILLS_ERRORS_SUCCESS,
  GET_BILLS_ERRORS_FAIL,
  GET_BILLS_FORMATTED_ERRORS_SUCCESS,
  GET_BILLS_FORMATTED_ERRORS_FAIL,
  GET_EXPORT_BILLS_SUCCESS,
  GET_EXPORTED_BILLS_FAIL,
  RESET_EXPORT_DATA,
  CLEAN_BILL_ERRORS,
} from "./actionTypes"

const INIT_STATE = {
  billList: [],
  billDetail: {},
  error: {},
  message: "",
  pagination: {},
  search: "",
  billErrors: [],
  billErrorPagination: {},
  file: "",
  price: 0,
}

const bills = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BILLS_SUCCESS:
      return {
        ...state,
        billList: action?.payload?.data || [],
        pagination: action?.payload?.pagination || {},
      }

    case GET_BILLS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_BILL_SUCCESS:
      return {
        ...state,
        billList: [...state.billList, action?.payload?.data || {}],
        message: action?.payload?.message || "",
      }

    case ADD_BILL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BILL_DETAIL_SUCCESS:
      return {
        ...state,
        billDetail: action.payload,
      }

    case UPDATE_BILL_SUCCESS:
      return {
        ...state,
        message: "Successfully updated bill!",
        billList: (state?.billList || []).map(bill => {
          return bill._id.toString() === action.payload?.data._id.toString()
            ? { bill, ...action.payload?.data }
            : bill
        }),
      }

    case UPDATE_BILL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BILL_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_BILL_SUCCESS:
      return {
        ...state,
        message: "Successfully bill deleted!",
        billList: (state?.billList || []).map(bill => {
          return bill._id.toString() === action.payload?._id.toString()
            ? { ...bill, status: statusTypes.Removed }
            : bill
        }),
      }

    case DELETE_BILL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }

    case UPDATE_BILL_ACCESS_SUCCESS:
      return {
        ...state,
        message: "Successfully bill updated!",
        billList: [],
      }

    case UPDATE_BILL_ACCESS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BILLS_ERRORS_SUCCESS:
      return {
        ...state,
        billErrors: action?.payload?.data || [],
        billErrorPagination: action?.payload?.pagination || {},
      }

    case CLEAN_BILL_ERRORS: return {
      ...state,
      billErrors: [],
      billErrorPagination:{}
    }

    case GET_BILLS_ERRORS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BILLS_FORMATTED_ERRORS_SUCCESS:
      return {
        ...state,
        billErrors: action?.payload?.data || [],
        billErrorPagination: action?.payload?.pagination || {},
      }

    case GET_BILLS_FORMATTED_ERRORS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_EXPORT_BILLS_SUCCESS:
      return {
        ...state,
        message: action.payload?.message,
        file: action.payload?.file,
        error: {},
      }

    case GET_EXPORTED_BILLS_FAIL:
      return {
        ...state,
        file: "",
        error: action.payload?.message || "Error occurred in export file.",
      }

    case RESET_EXPORT_DATA:
      return {
        ...state,
        error: {},
        message: "",
        file: "",
      }    
    

    default:
      return state
  }
}

export default bills
